import { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import Routing from './Component/Routing';
import SideBar from './Component/SideBar';
import './App.css'
import './Styles/index.scss'
import { dark_mode, set_admin, set_balance, set_from, set_netowrks, set_networkPairs, splash_loading_status } from './Utility/constants';
import { getNetworkPairs, getNetworks } from './Utility/helpers';
import classNames from 'classnames'
import Header from './Component/Header';

function App() {
  const [loading, setLoading] = useState(true)
  const dispatch = useDispatch()
  const [data, setData] = useState()
  const mode = useSelector(state => state.mode)
  const getinititalData = async () => {
    let allNetwork = await getNetworks()
    let allPairs = await getNetworkPairs()
    setData(allPairs)

    dispatch({ type: set_admin, payLoad: '' })
    dispatch({ type: set_balance, payLoad: 0 })
    dispatch({ type: set_netowrks, payLoad: allNetwork })
    dispatch({ type: set_networkPairs, payLoad: allPairs })
    dispatch({ type: set_from, payLoad: Object.keys(allPairs)[0] })

    setTimeout(() => {
      setLoading(false)
      dispatch({ type: splash_loading_status, payLoad: loading })
    }, 500);
  }

  useEffect(() => {
    getinititalData()
  }, [])

  const appClass = classNames({
    app: true,
    dark: mode === dark_mode ? true : false
  })

  return (

    <div className={appClass}>
      {/* {loading ? <div className="loader_holder"><div class="lds-ripple"><div></div><div></div></div></div>  */}
      {loading ? <div className='app_container'>
        <p className='loader-title'>Bridge initializing</p>
        <ul className="loader" >
          <li className="center" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}>
            <li className="item item-1" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-2" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-3" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-4" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-5" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-6" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-7" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
            <li className="item item-8" style={{ backgroundColor: mode === dark_mode ? "#fff" : "#EE31AF" }}></li>
          </li>
        </ul></div>
        :
        Object.keys(data[Object.keys(data)[0]]?.available_pair).length === 0 ? <p style={{
          fontSize: 30, fontWeight: 'bold',
          margin: 0,
          position: 'absolute',
          top: '50%',
          left: '50%',
          marginRight: -'50%',
          transform: 'translate(-50%, -50%)'
        }}>No Pair found Please Contact Admin</p> :
          <>
            <Routing />
          </>
      }

    </div>
  );
}

export default App;
